
const 	$ = jQuery,
		$overseas_magazine = $('.overseas-magazine');

if ( $overseas_magazine.length ) {

	$overseas_magazine.css({
		'display' : 'none'
	})

	$('#membership-country').on('change', function () {

		if ( $(this).val() != 'United Kingdom' ) {

			$overseas_magazine.show();

		} else {

			$overseas_magazine.hide();

		}

	});	

}
